import { Chess } from "@chesshotel/chess";
import { ChessTermType, MoveType, TermAction, } from "@chesshotel/types";
import { calculateAccuracy, evaluationToExpectedPoints } from "./statistics.js";
export function precalcEvaluationToWhitePerspective(precalc) {
    const direction = new Chess(precalc.fen).turn() === "w" ? 1 : -1;
    const sideToMoveScore = precalc.mateInMoves != null
        ? (precalc.mateInMoves > 0 ? 100 : -100)
        : precalc.score / 100;
    const score = direction * sideToMoveScore;
    return {
        score,
        expectedPoints: +evaluationToExpectedPoints(score).toFixed(2),
        secondBestScore: precalc.secondBestScore == null
            ? null : direction * precalc.secondBestScore / 100,
        mateInMoves: precalc.mateInMoves ?? null,
    };
}
export function parseStockfishEvaluation(line) {
    const match = line.match(/\bscore (cp|mate) (-?\d+)\b/);
    if (!match)
        return null;
    const value = Number(match[2]);
    return {
        score: match[1] === "cp" ? value / 100 : (value > 0 ? 100 : -100),
        mateInMoves: match[1] === "mate" ? value : null,
        multipv: Number(line.match(/\bmultipv (\d+)\b/)?.[1] ?? 1),
        pvMoves: (line.match(/\bpv (.+)/)?.[1] ?? "")
            .trim().split(/\s+/).filter(Boolean),
    };
}
export function getTerminalPositionEvaluation(fen) {
    const chess = new Chess(fen);
    const checkmate = chess.isCheckmate();
    if (!checkmate && !chess.isDraw())
        return null;
    const score = checkmate ? (chess.turn() === "b" ? 100 : -100) : 0;
    const term = checkmate
        ? ChessTermType.CHECKMATE
        : chess.isStalemate() ? ChessTermType.STALE_MATE : ChessTermType.DRAW;
    return {
        score,
        expectedPoints: checkmate ? (score > 0 ? 1 : 0) : 0.5,
        secondBestScore: null,
        bestMove: null,
        pvMoves: [],
        mateInMoves: checkmate ? 0 : null,
        chessTerms: [{ term, termAction: TermAction.PERFORM }],
        showPVTerm: null,
    };
}
export function classifyMove(previousExpectedPoints, currentExpectedPoints, move, moveIndex, bestMove, endMoveType) {
    let loss = moveIndex % 2 === 0
        ? currentExpectedPoints - previousExpectedPoints
        : previousExpectedPoints - currentExpectedPoints;
    loss = Math.round(loss * 100) / 100;
    if (endMoveType === ChessTermType.CHECKMATE ||
        (move && bestMove && move.toLowerCase() === bestMove.toLowerCase())) {
        return MoveType.BEST;
    }
    if (loss < 0.02)
        return MoveType.EXCELLENT;
    if (loss < 0.04)
        return MoveType.GOOD;
    if (loss < 0.1)
        return MoveType.INACCURACY;
    if (loss < 0.2)
        return MoveType.MISTAKE;
    if (loss >= 0.2)
        return MoveType.BLUNDER;
}
export function normalizeGameReviewPositions(positions) {
    return positions.map((position, index) => {
        const terminal = getTerminalPositionEvaluation(position.fen);
        const previous = positions[index - 1];
        if (terminal) {
            const checkmate = terminal.chessTerms[0].term === ChessTermType.CHECKMATE;
            const moveType = checkmate && position.moveIndex > 0
                ? MoveType.BEST
                : !previous ? position.moveType : classifyMove(previous.expectedPoints, terminal.expectedPoints, position.move, position.moveIndex, previous.bestMove, terminal.chessTerms[0].term);
            return { ...position, ...terminal, moveType };
        }
        if (position.move?.length === 5 && previous?.bestMove &&
            position.move.toLowerCase() === previous.bestMove.toLowerCase() &&
            ![MoveType.BOOK, MoveType.GREAT, MoveType.BRILLIANT].includes(position.moveType)) {
            return { ...position, moveType: MoveType.BEST };
        }
        return position;
    });
}
export function getGameReviewSummary(positions) {
    const whiteMoveTypes = Object.fromEntries(Object.values(MoveType).map(type => [type, 0]));
    const blackMoveTypes = { ...whiteMoveTypes };
    for (const position of positions) {
        if (position.moveIndex <= 0 || !position.moveType)
            continue;
        const counts = position.moveIndex % 2 === 1 ? whiteMoveTypes : blackMoveTypes;
        counts[position.moveType]++;
    }
    return {
        whiteMoveTypes,
        blackMoveTypes,
        whiteAccuracy: calculateAccuracy(positions, true),
        blackAccuracy: calculateAccuracy(positions, false),
    };
}
//# sourceMappingURL=evaluation.js.map